import { PasswordResetPage } from "@/interface/pages/password-reset-page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/users/password-reset")({
  component: RouteComponent,
});

function RouteComponent() {
  return <PasswordResetPage />;
} 